<template>
  <LayoutStudy
    :layout="mobile ? 'small_screen_layout' : $store.getters.sw_layout_study"
    :spacing="$store.getters.sw_layout_spacing_study"
    :asideHidden="tabMaximized"
    mainWidth="reports_layout"
    :class="[`laytsttd_reports`, { 'std-active': rep_messages }]"
    data-tst="reports_layer"
  >
    <template #hspots="{ onBottom }">
      <PokerHistoryEvents
        v-bind="hSpotsProps"
        :openToTop="onBottom"
        dialog="cards-dialog"
        :isCustomReportsPending
        class="solbrowser_hspots"
        style="--clr-hero: var(--clr-hero-default); z-index: 5"
        @click:prefill="handlePrefillClick"
      >
        <template
          v-if="sol_usingCussolReports && hSpot_street !== 'preflop'"
          #custom_showdown_message
        >
          <div
            class="text-center clr-grey weight_500"
            v-html="$t('common.gg_ai_turn_reports')"
          ></div>
        </template>
      </PokerHistoryEvents>
    </template>
    <template #aside>
      <StudyReportsAside
        :namespace="gamestateNamespace"
        :hasDisabledZeroFreqActions="sol_usingCussolReports"
        :viewProps="l_rep_dynamic.viewProps"
        :hero="$store.getters.rep_data_hero"
        :opponent="$store.getters.rep_data_opponent"
        :solution="$store.getters.rep_data_solution"
        :hasEmptyFlopBoard="sol_usingCussolReports"
        :isPreflop="rep_isPreflop"
        :showFlopContent="false"
        :showBetsIn
        :bettingInfo="rep_bettingInfo"
        :grouping
        :useHex
        :filterCombos="$store.getters.sol_filter_combos"
        :reportItem="$store.getters.rep_data_reportItem"
        :flopGroup="$store.getters.rep_data_flopGroup"
        :hasPremiumGameformat
        :gameformat
        :hSpot="$store.getters.rep_data_hSpot"
        :street="$store.getters.rep_data_street"
        :hSpotStreet="hSpot_street"
        :flopBoard="flopBoard"
        :turnFilterHand="$store.getters.rep_turn_filterHand"
        :linkParams="linkParams"
        :mobile
        :flopFilterDisabled="isCustomReportsPending && !l_rep_dynamic?.items?.length"
      />
    </template>
    <template #main>
      <div
        v-if="mobile ? !mobileLandscape : false"
        class="d-flex gw_box"
        style="--box-padding: 0 0.25rem; margin: 0 0 0.5rem 0; height: 2.5rem"
      >
        <StudyTableTile
          v-if="mobile && !filterActive"
          :hSpot="$store.getters.rep_data_hSpot"
          :street="$store.getters.rep_data_street"
          :hasEmptyFlopBoard="sol_usingCussolReports"
          :gameformat
          :mobile
          :solElite
        />
        <StudyFiltersPills
          v-else
          style="--clr-pills-back: var(--clr-black-1)"
          :alwaysVisible="true"
          class="my-auto ml-auto"
          :street="hSpot_street"
          soltab="reports"
          :filterCombos="$store.getters.sol_filter_combos"
          :hasFilterIntersection="false"
          :showBetsIn
        />
      </div>
      <TabBoxStudy
        class="flex-1"
        :hasGuide="true"
        :scrollToActiveTab="max1280"
        :reportsStreet="solElite.is_using ? 'flop' : hSpot_street"
        :namespace="gamestateNamespace"
        :isCustomReportsPending
        :customReportsPercentage
      >
        <template #tabs_after>
          <div
            v-if="!mobile"
            class="d-flex flex-1"
            style="min-width: 0; gap: 0.5rem"
          >
            <StudyFiltersPills
              class="ml-auto"
              :alwaysVisible="true"
              :street="hSpot_street"
              :showBetsIn
              :filterCombos="$store.getters.sol_filter_combos"
              :hasFilterIntersection="false"
              soltab="reports"
            />
            <div
              v-if="!mobile"
              class="d-flex"
              style="gap: 1px"
            >
              <StudyControlsReports
                style="z-index: 2"
                :street="hSpot_street"
                :flopBoard
                :turnFilterHand="$store.getters.rep_turn_filterHand"
              />
              <StudyControlsReportsFilters
                style="z-index: 2"
                :street="hSpot_street"
              />
              <StudyControlsMain style="z-index: 2" />
            </div>
          </div>
        </template>
        <template #default>
          <StudyReportsMain
            :namespace="gamestateNamespace"
            :items="l_rep_dynamic.items"
            :flopBoard
            :totalsItems="l_rep_dynamic.totalsItems"
            :viewProps="l_rep_dynamic.viewProps"
            :content="l_rep_dynamic.viewProps.content"
            :legendVertical="true"
            :colStyleKey="'strategy'"
            :useHex
            :playerRelPosition="$store.getters.rep_data_hero.relative_position"
            :isPreflop="rep_isPreflop"
            :reportItemId="$store.getters.rep_data_reportItemId"
            :hero="$store.getters.rep_data_hero"
            :opponent="$store.getters.rep_data_opponent"
            :solution="$store.getters.rep_data_solution"
            :controlsFlopGroup
            :flopGroup="$store.getters.rep_data_flopGroup"
            :eveqeqrAxes="$store.getters.rep_data_eveqeqrAxes"
            :grouping
            :showBetsIn
            :bettingInfo="rep_bettingInfo"
            :mobile
            :colorCoding="$store.getters.sw_reports_colorcoding01"
            :navResizeDeps="$store.getters.rep_nav_resizeDeps"
            :street="$store.getters.rep_data_street"
            :hSpot="$store.getters.rep_data_hSpot"
            :filterCombos="$store.getters.sol_filter_combos"
            :linkParams="linkParams"
            :hasPremiumGameformat
            :gameformat
            :hasReportsIncompleteMessage="isCustomReportsPending && reptab !== 'swv_flops'"
          />
        </template>
      </TabBoxStudy>
    </template>
    <template #after>
      <StudyMessageOverlay
        v-if="rep_messages"
        style="z-index: 2"
        :messages="rep_messages"
        :canAISolve="true"
        :hasShortcutBtn="hasShortcutBtn"
        :solElite
        :street="hSpot_street"
        :namespace="gamestateNamespace"
        :hasAiPrefillBtn
        pageKey="reports"
        :historySpots="historySpotsComplete"
        :hasCustomReportsHistory="hasCustomReportsHistory"
        @click:prefill="handlePrefillClick"
        @click:generate-report="getCustomReport"
        @click:show-reports-history="handleShowReportsHistoryClick"
      />
    </template>
  </LayoutStudy>
</template>

<script>
import { throttle } from 'lodash'
import StudyControlsMain from '@/components/Study/StudyControlsMain'
import StudyControlsReports from '@/components/Study/StudyControlsReports'
import StudyControlsReportsFilters from '@/components/Study/StudyControlsReportsFilters'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import LayoutStudy from '@/layouts/LayoutStudy'
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import TabBoxStudy from '@/components/Study/TabBoxStudy'
import StudyMessageOverlay from '@/components/Poker/Overlays/StudyMessageOverlay'
import StudyTableTile from '@/components/Study/StudyTableTile'
import StudyReportsAside from '@/components/Study/StudyReportsAside'
import StudyReportsMain from '@/components/Study/StudyReportsMain'
import { SNK } from '@/helpers/helpers'
import { namespaces } from '@/helpers/constants'
import { getSpotSelectedAction } from '@/store/gamestate/gamestate'
import * as R from 'remeda'

export default {
  name: 'ReportsDataLayer',
  components: {
    LayoutStudy,
    PokerHistoryEvents,
    TabBoxStudy,
    StudyMessageOverlay,
    StudyTableTile,
    StudyReportsAside,
    StudyReportsMain,
    StudyControlsMain,
    StudyControlsReports,
    StudyControlsReportsFilters,
    StudyFiltersPills,
  },
  props: {
    gamestateNamespace: { type: String, default: '' },
    mobileLandscape: Boolean,
    useHex: Boolean,
    mobile: Boolean,
    max1280: Boolean,
    grouping: String,
    showBetsIn: String,
    showEvIn: String,
    fullscreen: String,
  },
  data() {
    this.l_rep_params = {}
    this.l_sol_params = {}
    return {}
  },
  created() {
    if (this.sol_usingCussolReports) {
      this.$store.dispatch(SNK('rpfrm_emptyFrequenciesOnCurrentSpot', this.gamestateNamespace))
    }
  },
  beforeUnmount() {
    this.cancelCustomReportsPolling()
  },
  methods: {
    getData: throttle(function (caller) {
      this.rep_getData(caller)
    }, 40),
    async rep_getData(caller) {
      if (!this.hSpot) return
      if (this.historyLoading) return
      if (this.hSpot.placeholder) return
      if (this.hSpot.type === 'showdown') return
      if (['preflop', 'river'].includes(this.hSpot_street)) {
        this.cancelCustomReportsPolling()
        this.emptyParams()
        return
      }
      if (
        this.hSpot_street === 'turn'
          ? this.$store.getters[SNK('street_board', this.gamestateNamespace)]('flop').includes('Ee')
          : false
      ) {
        this.cancelCustomReportsPolling()
        this.emptyParams()
        return
      }

      // Only update params and restart polling if params have changed
      if (this.paramsAreNotSynced()) {
        this.syncParams()

        if (this.sol_usingCussolReports) {
          this.checkCustomReport()
        } else {
          this.$store.dispatch('api_poker_reports', { namespace: this.gamestateNamespace })
        }
        this.resetHistoryErrorMessages()
      }
    },
    resetHistoryErrorMessages() {
      // TODO add /tree-preview to this
      const calls = ['api_poker_history', 'api_poker_next_actions']
      calls.forEach(mutation => {
        if (this.$store.getters.api_get(mutation).error) {
          this.$store.commit('api_reset', { namespace: null, key: mutation })
        }
      })
    },
    handlePrefillClick() {
      const tmpNamespace = 'tmp/primary'
      const mode =
        this.$store.getters.flop_board && this.solElite.can_use ? 'keepboard' : 'createnew'
      let dialog = 'solfigr-create-custom-solution-dialog'
      dialog = `${dialog}_namespace-${tmpNamespace}_instaPrefill-true_mode-${mode}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    checkCustomReport() {
      this.syncParams()
      this.$store.dispatch('api_poker_custom_report_check')
    },
    getCustomReport() {
      this.syncParams()
      this.$store.dispatch('api_poker_custom_report_get')
    },
    syncParams() {
      const params = this.$store.getters[SNK('solparams_reports', this.gamestateNamespace)]
      this.l_rep_params = JSON.parse(JSON.stringify(params))
    },
    emptyParams() {
      this.l_rep_params = {}
    },
    paramsAreNotSynced() {
      const params = this.$store.getters[SNK('solparams_reports', this.gamestateNamespace)]
      return JSON.stringify(this.l_rep_params) !== JSON.stringify(params)
    },
    handleShowReportsHistoryClick() {
      this.syncParams()

      if (this.mobile) {
        const tmpNamespace = 'tmp/primary'
        this.$store.dispatch('poker_copy_module', {
          from_namespace: this.gamestateNamespace,
          to_namespace: tmpNamespace,
          queryGroup: 'gmf-selektor',
        })
        this.$store.dispatch('poker_copy_module', {
          from_namespace: this.gamestateNamespace,
          to_namespace: tmpNamespace,
          queryGroup: 'router-to-gmf-selektor',
        })
        this.$store.dispatch('poker_copy_module', {
          from_namespace: this.gamestateNamespace,
          to_namespace: tmpNamespace,
          queryGroup: 'router',
        })

        const dialog = `solutions-dialog_tmpNamespace-${tmpNamespace}`
        this.$store.dispatch('router_set_dialogs', dialog)
        return
      }

      // Open the floating gmf selector dialog
      this.$store.commit('globals_set', { key: 'floating_gmf_visible', value: true })

      // Switch to reports tab in the floating gmf selector dialog
      this.$store.dispatch(SNK('sol_switchSolTypeNEW', namespaces.REPORTS), {
        namespace: namespaces.REPORTS,
        channelId: `floating_gmf_${Date.now()}`,
        gmfs_solution_tab: 'ai_reports',
        solType: 'custom',
      })
    },
    cancelCustomReportsPolling() {
      this.$store.dispatch('api_poker_custom_reports_cancel')
    },
  },
  computed: {
    sol_usingCussolReports() {
      return this.$store.getters[SNK('sol_usingCussolReports', this.gamestateNamespace)] // refresh history for all spots for reports & strategy toggle
    },
    hasCustomReportsHistory() {
      return this.$store.getters.api_get_data('api_custom_aggregated_report_table')?.length
    },
    requiredToGenerateReport() {
      const status = this.$store.getters.rep_data_customReportMeta.status
      return this.sol_usingCussolReports && status === 'not_exist'
    },
    hSpotsProps() {
      return {
        hasInitialLoad: true,
        namespace: this.gamestateNamespace,
        hasGameformat: true, // show first tile with solution info
        hasWatcherEnabled: true,
        clickableFlopSolutionEndNode: true,
        isMinimizedVertical: this.mobile && !this.$store.getters.screen_landscape,
        mobile: this.mobile,
        shortcutBtnsHorizontal: true, // show ShortcutBtns
        canAISolve: true, // passed to ShortcutBtns which passes it to shortcut dialog which is shown for presolved sols only
        hiddenShortcutBtns: this.sol_usingCussolReports ? ['shortcut', 'save_spot'] : [],
        solElite: this.solElite,
        skeletonTiles: this.solElite.is_preflop ? 1 : null,
        hasTurnPreload: !this.sol_usingCussolReports, // whenether to make turn preload call for (presolved sols only)
        noNextActionsWithoutBoard: false,
        useTreePreview: false,
        useTreePreviewReports: this.sol_usingCussolReports,
        customTreeId: this.sol_usingCussolReports ? this.solElite.custom_tree_id : '',
        ggStreet: this.sol_usingCussolReports && 'turn',
        clickableGG: !this.sol_usingCussolReports,
        hasGGSaveSpot: !this.sol_usingCussolReports,
        hasEmptyBoard: this.sol_usingCussolReports,
        clickableBoard: !this.sol_usingCussolReports,
        showBoardWhenLoading: !this.sol_usingCussolReports,
        hasNodeEdit: false,
        hasNodeMenu: false,
        hasFlopPrefillBtn: !this.sol_usingCussolReports,
        hasFlopSolutionEndNode: !this.sol_usingCussolReports, // shows message that presolved solutions end - continue with AI (presolved sols only),
        hasDisabledZeroFreqActions: this.sol_usingCussolReports,
        requiredToGenerateReport: this.requiredToGenerateReport,
      }
    },
    linkParams() {
      const query_history = this.$store.getters[SNK('query_history', this.gamestateNamespace)]
      return this.sol_usingCussolReports
        ? {
            custree_id: this.solElite.custom_tree_id,
            preflop_actions: query_history.preflop_actions,
            flop_actions: query_history.flop_actions,
            history_spot: this.hSpot?.id,
            soltab: 'strategy',
            solution_type: 'custom',
            gmfs_solution_tab: 'ai_sols',
            autocreate_custom_solution: true,
          }
        : {}
    },
    hasShortcutBtn() {
      return !this.sol_usingCussolReports
    },
    l_rep_dynamic() {
      const res = {
        items: this.$store.getters.rep_data_items(),
        totalsItems: this.$store.getters.rep_data_totalsItems,
        viewProps: this.$store.getters.rep_data_viewProps,
      }
      return this.$store.getters.rep_data_viewProps ? res : res
    },
    rep_isPreflop() {
      return this.$store.getters.rep_data_street === 'preflop'
    },
    filterActive() {
      return (
        this.$store.getters.sol_filter_combos.actions.length ||
        this.$store.getters.rep_turn_filterHand ||
        Object.keys(this.repFlopFilterParams).length
      )
    },
    tabMaximized() {
      if (this.mobile) return false
      if (this.mobileLandscape) return false
      return this.$store.getters.sw_study_reports_fullscreen === 'on'
    },
    gameformat() {
      // TODO this is misleading but its a hack for down the line props
      return this.solElite?.want_use
        ? { gm_type: 'elite', players: 0 }
        : this.$store.getters[SNK('gameformat', this.gamestateNamespace)]
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.gamestateNamespace)]
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },
    flopBoard() {
      return this.$store.getters[SNK('flop_board', this.gamestateNamespace)]
    },
    hSpot() {
      return this.$store.getters[SNK('history_spot', this.gamestateNamespace)]
    },
    historySpotsComplete() {
      return this.$store.getters[SNK('history_spots_complete', this.gamestateNamespace)]
    },
    hSpot_street() {
      return this.hSpot?.street
    },
    preflopOnlyGametype() {
      return (
        !this.sol_usingCussolReports &&
        this.$store.getters[
          `${this.gamestateNamespace ? `${this.gamestateNamespace}/` : ''}preflopOnlyGametype`
        ]
      )
    },
    treePreviewCall() {
      return this.$store.getters.api_get('api_poker_tree_preview', this.gamestateNamespace)
    },
    historyCall() {
      return this.$store.getters.api_get('api_poker_history', this.gamestateNamespace)
    },
    historyLoading() {
      return (
        this.nextActionsCall?.loading || this.historyCall?.loading || this.treePreviewCall.loading
      )
    },
    historyStatus() {
      return this.historyCall.status
    },
    historyError() {
      return this.nextActionsCall?.error || this.historyCall?.error
    },
    nextActionsCall() {
      return this.$store.getters.api_get('api_poker_next_actions', this.gamestateNamespace)
    },
    nextActionsStatus() {
      return this.nextActionsCall.status
    },
    cusssolCall() {
      return this.$store.getters.api_get('api_poker_custom_solution', this.gamestateNamespace)
    },
    cussolLoading() {
      return this.cusssolCall?.loading
    },
    cussolPostStatus() {
      return this.cusssolCall?.method === 'post' && this.cusssolCall?.status
    },
    rep_apiCall() {
      return this.$store.getters.api_get('api_poker_reports')
    },
    rep_custom_report_check_call() {
      return this.$store.getters.api_get('api_custom_aggregated_report_check')
    },
    rep_custom_report_call() {
      return this.$store.getters.api_get('api_custom_aggregated_report')
    },

    // TODO could be simplified under on {}
    gmfCommon() {
      const gameformatTrial = this.gameformat?.subscription_tier === 'TRIAL'
      const gameformatStarter = this.gameformat?.subscription_tier === 'STARTER'
      const gameformatPremium = this.gameformat?.subscription_tier === 'PREMIUM'
      const gameformatElite = this.gameformat?.subscription_tier === 'ELITE'
      const gameformatPurchased = gameformatStarter || gameformatPremium || gameformatElite
      return {
        gameformatTrial,
        gameformatStarter,
        gameformatPremium,
        gameformatElite,
        gameformatPurchased,
        gameformatFree: !gameformatTrial && !gameformatPurchased,
      }
    },
    customReportsGenerationCompletness() {
      return (
        this.$store.getters.rep_data_customReportMeta.solved_board_count /
        this.$store.getters.rep_data_customReportMeta.total_board_count
      )
    },
    customReportsPercentage() {
      const percentage = Math.floor(this.customReportsGenerationCompletness * 100)
      return this.rep_apiCall.loading ? 0 : percentage || 0
    },
    rep_messages() {
      const loading =
        !this.hSpot ||
        this.rep_apiCall.loading ||
        this.historyLoading ||
        this.solElite.loading_what === 'custom_solution_tree'

      const customReportsLoading =
        this.rep_custom_report_check_call.loading ||
        this.rep_custom_report_call.loading ||
        this.isCustomReportsPending

      const opts = [
        {
          key: 'loading',
          val: loading,
        },
        {
          key: 'loading_custom_reports',
          val:
            this.sol_usingCussolReports &&
            customReportsLoading &&
            !this.customReportsGenerationCompletness,
        },
        { key: 'no_river', val: this.hSpot_street === 'river' },
        { key: 'postflop_equity_only', val: this.hSpot_street === 'preflop' },
        {
          key: 'no_3way_custom_reports',
          val:
            this.$store.getters.user_has_flag('SOL_3WAY') &&
            this.solElite.want_use &&
            this.solElite.custom_solution_tree?.response?.data?.players.length > 2,
        },
        {
          key: 'custom_reports_payment_required',
          val:
            this.sol_usingCussolReports &&
            this.requiredToGenerateReport &&
            !customReportsLoading &&
            !this.hSpot?.placeholder,
        },
        {
          key: 'custom_reports_elite_only',
          val: !this.sol_usingCussolReports && this.solElite.is_using,
        },
        { key: 'preflopOnlyGametype', val: this.preflopOnlyGametype },
        {
          key: 'spins_reports_basic_only',
          val:
            this.rep_apiCall.status === 204 &&
            this.gameformat.group === 'spins' &&
            this.gameformat.type !== 'basic',
        },
        {
          key: 'select_board_strategy',
          val:
            this.hSpot_street === 'turn'
              ? this.$store.getters[SNK('street_board', this.gamestateNamespace)]('flop').includes(
                  'Ee',
                )
              : false,
        },
        {
          key: 'filtered_204',
          val:
            this.rep_apiCall.status === 204 &&
            (this.$store.getters.turn_filter_hand || Object.keys(this.repFlopFilterParams).length),
        },
        {
          key: 'trialUser403',
          val: this.gmfCommon.gameformatTrial && this.rep_apiCall.status === 403,
        },
        {
          key: 'starterUser403',
          val: this.gmfCommon.gameformatStarter && this.rep_apiCall.status === 403,
        },
        {
          key: 'FREE_unavailable',
          val: this.gmfCommon.gameformatFree && this.rep_apiCall.status === 403,
        },
        { key: '204', val: this.rep_apiCall.status === 204 },
        { key: '403', val: this.rep_apiCall.status === 403 },
        { key: '429', val: this.rep_apiCall.status === 429 },
        {
          key: 'turnZeroDataValues',
          val: this.hSpot_street === 'turn' ? this.turnZeroDataValues : false,
        },
        // 200 res code but no data
        {
          key: 'error_loading_solution',
          val:
            this.rep_apiCall.error ||
            this.historyError ||
            ['failed', 'max_retries_reached'].includes(
              this.$store.getters.rep_data_customReportMeta.status,
            ),
        },
      ]
      let res = null
      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })
      return res
    },
    turnZeroDataValues() {
      // @TODO add flag here
      const res =
        this.$store.getters.api_get_data('api_poker_reports')?.player_totals ||
        this.$store.getters.api_get_data('api_poker_reports')?.totals
      return !res
    },
    rep_bettingInfo() {
      return { showEvIn: this.showEvIn, pot: this.$store.getters.rep_data_hSpot.pot }
    },
    reptab() {
      return this.hSpot_street === 'flop'
        ? this.$store.getters.sw_reports_flop_grouping
        : this.$store.getters.sw_reports_turn_grouping
    },
    repFlopFilterParams() {
      return this.$store.getters.ffrf.params || {} // filters_reports_flop
    },
    repFilters() {
      return JSON.stringify(this.repFlopFilterParams) + this.$store.getters.rep_turn_filterHand
    },
    flopEliteForbidden() {
      return (
        !this.solElite.is_preflop &&
        this.solElite.is_using &&
        (this.nextActionsStatus === 403 ||
          this.historyStatus === 403 ||
          this.cussolPostStatus === 403)
      )
    },
    isCustomReportsPending() {
      return (
        this.sol_usingCussolReports &&
        this.$store.getters.rep_data_customReportMeta.status === 'pending'
      )
    },
    hasAiPrefillBtn() {
      if (!this.solElite.can_use) return false
      if (this.sol_usingCussolReports) return false

      const lastPreflopSpot = R.findLast(this.historySpotsComplete, i => i.street === 'preflop')
      const selectedAction = getSpotSelectedAction({ spot: lastPreflopSpot })
      const gameformat = this.$store.getters[SNK('gameformat', this.gamestateNamespace)]
      return !!(selectedAction?.can_ai_solve && gameformat.subscription_tier)
    },
    controlsFlopGroup() {
      return this.$store.getters.rep_data_street === 'flop'
        ? this.$store.getters.sw_reports_flop_grouping
        : this.$store.getters.sw_reports_turn_grouping
    },
  },
  watch: {
    sol_usingCussolReports(value) {
      this.cancelCustomReportsPolling()
    },
    repFilters() {
      this.getData('repFilters')
    },
    reptab() {
      this.getData('reptab')
    },
    hSpot() {
      this.getData('hSpot')
    },
    fullscreen() {
      this.$store.dispatch('globals_action', `horizontal_scroll_check`)
    },
  },
}
</script>
